import React from 'react';

const TwitterIcon = () => {
  return (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none">
      <path
        d="M24.5 43.4028C14.5589 43.4028 6.5 35.344 6.5 25.4028C6.5 15.4617 14.5589 7.40283 24.5 7.40283C34.4411 7.40283 42.5 15.4617 42.5 25.4028C42.5 35.344 34.4411 43.4028 24.5 43.4028Z"
        stroke="#F2F2F2"
      />
      <path
        d="M14.3722 31.5722C16.1545 32.7025 18.2686 33.3567 20.5348 33.3567C26.9016 33.3567 32.0627 28.195 32.0627 21.8288C32.0627 21.6699 32.0594 21.5121 32.0532 21.3548C32.2835 21.1736 33.7078 20.032 34.0569 19.2981C34.0569 19.2981 32.9003 19.7788 31.7683 19.892C31.7661 19.892 31.7633 19.8926 31.7611 19.8926C31.7611 19.8926 31.7633 19.8914 31.7672 19.8887C31.8715 19.819 33.3297 18.8263 33.5272 17.6436C33.5272 17.6436 32.7091 18.0802 31.5636 18.4622C31.374 18.5252 31.1755 18.5872 30.9709 18.6446C30.2325 17.8566 29.183 17.3647 28.0181 17.3647C25.7835 17.3647 23.9729 19.1749 23.9729 21.4077C23.9729 21.7228 24.0091 22.0295 24.0777 22.3239C23.7654 22.3111 19.0103 22.0445 15.7753 18.127C15.7753 18.127 13.8419 20.7664 16.9275 23.4805C16.9275 23.4805 15.9895 23.4431 15.1803 22.9596C15.1803 22.9596 14.8831 26.1572 18.3773 26.9747C18.3773 26.9747 17.6898 27.2352 16.5929 27.0495C16.5929 27.0495 17.2063 29.6331 20.3108 29.8746C20.3108 29.8746 17.8559 32.0922 14.3711 31.5719L14.3722 31.5722Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export default TwitterIcon;
